import { render, staticRenderFns } from "./DeadstockPopup.vue?vue&type=template&id=61b2bdac&scoped=true&"
import script from "./DeadstockPopup.vue?vue&type=script&lang=js&"
export * from "./DeadstockPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeadstockPopup.vue?vue&type=style&index=0&id=61b2bdac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2bdac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
